import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MIXPANEL_EVENTS } from "../config/mixPanelEvents";
import { PAGES_PATH } from "../navigation/params";
import { userActivityLogger } from "../utils/mixpanel";
import useWellnessPurchaseData from "./redux-hooks/wellness-purchase-store/wellness-purchase-store";
import useWellnessPlans from "./useWellnessPlans";
import { useGetAutoRenewalPreference } from "../services/renewal-preference/renewal-preference.service";

interface IUseScratchPayRenewalParams {
  petId: string;
  petName: string;
  planName: string;
  planType?: string;
  subscriptionId: string;
  scratchpayPlanId?: number;
}

export const useScratchPayRenewal = ({
  petId,
  petName,
  planName,
  planType,
  subscriptionId,
  scratchpayPlanId,
}: IUseScratchPayRenewalParams) => {
  const navigate = useNavigate();
  const { setWellnessPurchaseData } = useWellnessPurchaseData();
  const { fetchCatalogItems, getPlanDataByPlanId } = useWellnessPlans();
  const { preference, loading: preferenceLoading } = useGetAutoRenewalPreference(subscriptionId);

  useEffect(() => {
    if (petId) {
      fetchCatalogItems(petId);
    }
  }, [petId]);

  const handleApplyNow = () => {
    if (!preference?.newPlanId || !planType || !scratchpayPlanId) {
      return;
    }

    userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_RENEWAL_APPLY_NOW_CLICKED, {
      pet_id: petId,
      pet_name: petName,
      plan_name: planName,
      payment_method: "ScratchPay",
    });

    const currentPlanData = getPlanDataByPlanId(preference.newPlanId, planType);

    if (currentPlanData) {
      setWellnessPurchaseData({
        ...currentPlanData,
        scratchpayPlanId: scratchpayPlanId,
        preferredBillingCycle: "perMonth",
        fromScratchPayRenewal: true,
      });
    }

    navigate(`${PAGES_PATH.WELLNESS_PLAN_DETAILS}${PAGES_PATH.WELLNESS_PLAN_CONFIRM_AND_PAY}?id=${petId}`);
  };

  return {
    handleApplyNow,
    preference,
    preferenceLoading,
  };
};

